import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "bg-gray-100 h-full w-full relative text-2xl" }
const _hoisted_2 = { class: "bg-purple-600 text-white px-4 py-3 flex items-center justify-between sticky top-0 z-10" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "text-xl font-semibold" }
const _hoisted_5 = { class: "bg-white p-4 mb-4 text-2xl pl-24 pr-24" }
const _hoisted_6 = { class: "flex justify-between items-center mb-3" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "text-xl text-gray-500" }
const _hoisted_9 = { class: "text-purple-600 font-medium" }
const _hoisted_10 = { class: "border-t pt-3" }
const _hoisted_11 = { class: "flex justify-between mb-2" }
const _hoisted_12 = { class: "flex justify-between mb-2" }
const _hoisted_13 = { class: "flex justify-between" }
const _hoisted_14 = { class: "bg-white mb-4 text-2xl pl-24 pr-24" }
const _hoisted_15 = { class: "p4" }
const _hoisted_16 = { class: "space-y-3 mb-4" }
const _hoisted_17 = { class: "font-medium text-left" }
const _hoisted_18 = {
  key: 0,
  class: "text-xl text-green-500"
}
const _hoisted_19 = { class: "text-gray-500 text-left" }
const _hoisted_20 = { class: "text-right" }
const _hoisted_21 = { class: "border-t border-gray-100 pt-3 pb-3 space-y-2" }
const _hoisted_22 = { class: "flex justify-between" }
const _hoisted_23 = { class: "text-gray-600" }
const _hoisted_24 = { class: "text-base text-gray-500" }
const _hoisted_25 = { class: "flex justify-between items-center" }
const _hoisted_26 = { class: "flex items-center" }
const _hoisted_27 = { class: "text-gray-600" }
const _hoisted_28 = { class: "flex justify-between" }
const _hoisted_29 = {
  key: 0,
  class: "flex justify-between text-green-600"
}
const _hoisted_30 = {
  key: 1,
  class: "flex justify-between text-red-500 items-center"
}
const _hoisted_31 = { class: "bg-white mb-32 text-2xl pl-24 pr-24" }
const _hoisted_32 = { class: "p-4 pb-8" }
const _hoisted_33 = { class: "payment-methods" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "payment-content text-left" }
const _hoisted_36 = { class: "font-medium" }
const _hoisted_37 = { class: "text-xs text-gray-500" }
const _hoisted_38 = { class: "fixed bottom-0 left-0 right-0 bg-white p-4 border-t border-gray-200 text-2xl pl-24 pr-24" }
const _hoisted_39 = { class: "flex justify-between items-center mb-3" }
const _hoisted_40 = { class: "text-2xl font-bold text-purple-600" }
const _hoisted_41 = { class: "flex justify-between items-center mb-4" }
const _hoisted_42 = { class: "text-xl font-bold" }
const _hoisted_43 = { class: "text-center" }
const _hoisted_44 = { class: "font-bold text-xl mb-2" }
const _hoisted_45 = {
  key: 1,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
}

import { ref, computed, onMounted } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  import { getOrder } from '@/service/order';
  import { showDialog } from 'vant';

  interface OrderDish {
    name: string;
    price: number;
    quantity: number;
    isAddedFood?: boolean; // 是否为加菜
  }

  interface PaymentMethod {
    type: string;
    name: string;
    description: string;
    icon: string;
    iconClass: string;
  }

  interface OrderDetail {
    orderId: number;
    orderNo: string;
    tableNumber: number;
    personCount: number;
    createTime: string;
    orderStatus: number;
    totalAmount: number;
    paymentAmount?: number; // 已支付金额
    remainAmount?: number; // 剩余应付金额
    foodList: Array<{
      foodName: string;
      shopFoodName: string;
      price: number;
      quantity: number;
      addType: number; // 1-正常，2-加菜
      amount: number;
    }>;
  }

  // 响应式数据
  
export default /*@__PURE__*/_defineComponent({
  __name: 'OrderCheckOutView',
  setup(__props) {

  const router = useRouter();
  const route = useRoute();

  // 接口定义
  const tableNumber = ref(0);
  const orderId = ref(0);
  const orderNo = ref('');
  const peopleCount = ref(0);
  const orderTime = ref('');
  const diningDuration = ref('');
  const selectedPayment = ref('wechat');
  const showQRModal = ref(false);
  const showSuccessModal = ref(false);
  const discountAmount = ref(0);
  const loading = ref(false);

  // 多次支付相关字段
  const totalAmount = ref(0); // 订单总金额
  const paymentAmount = ref(0); // 已支付金额
  const remainAmount = ref(0); // 剩余应付金额

  // 服务费配置（可调整）
  const serviceFeeRate = ref(0); // 服务费比例，0表示无服务费
  const serviceFeeModalVisible = ref(false);
  const tempServiceFeeRate = ref(0);

  // 订单菜品数据 - 改为动态数据
  const orderDishes = ref<OrderDish[]>([]);

  // 支付方式配置
  const paymentMethods = ref<PaymentMethod[]>([
    {
      type: 'employee',
      name: '员工卡',
      description: '员工卡支付',
      icon: 'fas fa-address-card',
      iconClass: 'cash',
    },
    {
      type: 'wechat',
      name: '微信支付',
      description: '使用微信扫码支付',
      icon: 'fab fa-weixin',
      iconClass: 'wechat',
    },
    {
      type: 'alipay',
      name: '支付宝',
      description: '使用支付宝扫码支付',
      icon: 'fab fa-alipay',
      iconClass: 'alipay',
    },
    {
      type: 'cash',
      name: '现金支付',
      description: '使用现金结账',
      icon: 'fas fa-money-bill-wave',
      iconClass: 'cash',
    },
    {
      type: 'card',
      name: '刷卡支付',
      description: '使用银行卡支付',
      icon: 'fas fa-credit-card',
      iconClass: 'card',
    },
  ]);

  // 计算属性
  const totalDishCount = computed(() => {
    return orderDishes.value.reduce((sum, dish) => sum + dish.quantity, 0);
  });

  const subtotal = computed(() => {
    return orderDishes.value.reduce((sum, dish) => sum + dish.price * dish.quantity, 0);
  });

  const serviceFee = computed(() => {
    return Math.round(subtotal.value * serviceFeeRate.value);
  });

  const finalAmount = computed(() => {
    // 使用API返回的剩余应付金额，如果没有则使用计算值
    if (remainAmount.value > 0) {
      return remainAmount.value;
    }
    return subtotal.value + serviceFee.value - discountAmount.value;
  });

  // 加载订单详情数据
  const loadOrderDetail = async () => {
    try {
      if (!orderId.value) {
        console.error('订单ID为空');
        return;
      }

      loading.value = true;
      const response = await getOrder({ orderId: orderId.value });

      if (response.code === 200 && response.result) {
        const orderData = response.result;

        // 更新基础信息
        orderNo.value = orderData.orderNo || '';
        // 从tableName提取桌号数字，如果tableName是"3号桌"格式
        if (orderData.tableName) {
          const tableMatch = orderData.tableName.match(/(\d+)/);
          tableNumber.value = tableMatch ? parseInt(tableMatch[1]) : 0;
        }
        peopleCount.value = orderData.personCount || 0;

        // 更新支付相关字段
        totalAmount.value = orderData.totalAmount || 0;
        paymentAmount.value = orderData.paymentAmount || 0;
        remainAmount.value = orderData.remainAmount || 0;

        // 处理时间格式
        if (orderData.createTime) {
          if (orderData.createTime instanceof Date) {
            orderTime.value = formatDateTime(orderData.createTime.getTime());
          } else if (typeof orderData.createTime === 'string') {
            orderTime.value = formatDateTime(orderData.createTime);
          }
        }

        // 计算用餐时长
        if (orderData.createTime) {
          let orderDate: Date;
          if (orderData.createTime instanceof Date) {
            orderDate = orderData.createTime;
          } else {
            orderDate = new Date(orderData.createTime);
          }
          const now = new Date();
          const diffMs = now.getTime() - orderDate.getTime();
          const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
          const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
          diningDuration.value = `${diffHours}小时${diffMinutes}分钟`;
        }

        // 转换菜品数据
        if (orderData.foodList && Array.isArray(orderData.foodList)) {
          orderDishes.value = orderData.foodList.map((food: any) => ({
            name: food.foodName || food.shopFoodName || '',
            price: food.price || 0,
            quantity: food.quantity || 1,
            isAddedFood: food.addType === 2, // addType: 1-正常，2-加菜
          }));
        }

        console.log('订单详情加载成功:', orderData);
        console.log('转换后的菜品数据:', orderDishes.value);
      } else {
        showDialog({ message: response.msg || '加载订单详情失败' });
      }
    } catch (error) {
      console.error('加载订单详情失败:', error);
      showDialog({ message: '加载订单详情失败，请稍后重试' });
    } finally {
      loading.value = false;
    }
  };

  // 方法
  const formatDateTime = (dateTime: string | number) => {
    let date: Date;

    if (typeof dateTime === 'string') {
      date = new Date(dateTime);
    } else if (typeof dateTime === 'number') {
      date = new Date(dateTime);
    } else {
      return '';
    }

    // 检查日期是否有效
    if (isNaN(date.getTime())) {
      return '';
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hour}:${minute}`;
  };

  const selectPayment = (paymentType: string) => {
    selectedPayment.value = paymentType;
  };

  const getPaymentMethodName = (type: string) => {
    const method = paymentMethods.value.find((m) => m.type === type);
    return method ? method.name : '支付';
  };

  const completePayment = () => {
    if (
      selectedPayment.value === 'cash' ||
      selectedPayment.value === 'card' ||
      selectedPayment.value === 'employee'
    ) {
      // 现金、刷卡或员工卡支付直接显示成功
      showPaymentSuccess();
    } else {
      // 显示支付二维码
      showQRCode();
    }
  };

  const showQRCode = () => {
    showQRModal.value = true;
  };

  const hideQRCode = () => {
    showQRModal.value = false;
  };

  const simulatePayment = () => {
    hideQRCode();
    showPaymentSuccess();
  };

  const showPaymentSuccess = () => {
    showSuccessModal.value = true;
  };

  const returnToTables = () => {
    router.push('/tableManage');
  };

  const applyDiscount = () => {
    alert('优惠券功能将在下一版本推出');
  };

  const printReceipt = () => {
    const printWindow = window.open('', '_blank');
    if (!printWindow) return;

    const currentTime = new Date();

    printWindow.document.write(`
    <html>
      <head>
        <title>结账小票</title>
        <style>
          body { font-family: 'Courier New', monospace; font-size: 14px; margin: 20px; }
          .receipt-header { text-align: center; border-bottom: 2px dashed #000; padding-bottom: 10px; margin-bottom: 15px; }
          .receipt-title { font-size: 18px; font-weight: bold; margin-bottom: 5px; }
          .receipt-item { display: flex; justify-content: space-between; margin-bottom: 8px; }
          .receipt-footer { border-top: 2px dashed #000; padding-top: 10px; margin-top: 15px; text-align: center; font-size: 12px; }
          .total-line { border-top: 1px solid #000; padding-top: 8px; margin-top: 8px; font-weight: bold; }
        </style>
      </head>
      <body>
        <div class="receipt-header">
          <div class="receipt-title">美食集市 - 结账小票</div>
          <div>订单号: #${orderNo.value}</div>
        </div>

        <div class="receipt-item">
          <span>桌号:</span>
          <span>${tableNumber.value}号桌</span>
        </div>
        <div class="receipt-item">
          <span>用餐人数:</span>
          <span>${peopleCount.value}人</span>
        </div>
        <div class="receipt-item">
          <span>下单时间:</span>
          <span>${orderTime.value}</span>
        </div>
        <div class="receipt-item">
          <span>支付方式:</span>
          <span>${getPaymentMethodName(selectedPayment.value)}</span>
        </div>

        <div style="margin: 15px 0; text-align: center; font-weight: bold;">消费明细</div>

        ${orderDishes.value
          .map(
            (dish) => `
          <div class="receipt-item">
            <span>${dish.name}${dish.isAddedFood ? '(加菜)' : ''} x${dish.quantity}</span>
            <span>¥${(dish.price * dish.quantity).toFixed(2)}</span>
          </div>
        `,
          )
          .join('')}

        <div class="receipt-item">
          <span>小计:</span>
          <span>¥${subtotal.value.toFixed(2)}</span>
        </div>
        <div class="receipt-item">
          <span>服务费 (${serviceFeeRate.value * 100}%):</span>
          <span>¥${serviceFee.value.toFixed(2)}</span>
        </div>
        <div class="receipt-item">
          <span>订单总金额:</span>
          <span>¥${totalAmount.value.toFixed(2)}</span>
        </div>
        ${
          paymentAmount.value > 0
            ? `
        <div class="receipt-item">
          <span>已付金额:</span>
          <span>¥${paymentAmount.value.toFixed(2)}</span>
        </div>
        `
            : ''
        }
        ${
          discountAmount.value > 0
            ? `
        <div class="receipt-item">
          <span>优惠减免:</span>
          <span>-¥${discountAmount.value.toFixed(2)}</span>
        </div>
        `
            : ''
        }

        <div class="receipt-footer">
          <div class="total-line" style="font-size: 16px; font-weight: bold; margin-bottom: 10px;">
            本次支付金额: ¥${finalAmount.value.toFixed(2)}
          </div>
          <div>打印时间: ${currentTime.toLocaleString()}</div>
          <div style="margin-top: 10px;">谢谢惠顾，欢迎再次光临！</div>
        </div>
      </body>
    </html>
  `);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
  };

  const goBack = () => {
    router.back();
  };

  const adjustServiceFee = () => {
    // 实现调整服务费的逻辑
    console.log('调整服务费');
  };

  // 生命周期
  onMounted(async () => {
    // 从URL获取参数
    const tableParam = route.query.table;
    const orderIdParam = route.query.orderId;

    if (tableParam) {
      tableNumber.value = parseInt(tableParam as string);
    }

    if (orderIdParam) {
      orderId.value = parseInt(orderIdParam as string);
      // 加载订单详情
      await loadOrderDetail();
    } else {
      showDialog({ message: '缺少订单ID参数' });
    }
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "text-white mr-3",
          onClick: goBack
        }, _cache[1] || (_cache[1] = [
          _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1)
        ])),
        _createElementVNode("h1", _hoisted_4, _toDisplayString(tableNumber.value) + "号桌 - 结账", 1)
      ]),
      _createElementVNode("div", { class: "flex items-center" }, [
        _createElementVNode("button", {
          class: "mr-4",
          onClick: printReceipt
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "fas fa-print text-white" }, null, -1)
        ])),
        _cache[3] || (_cache[3] = _createElementVNode("button", null, [
          _createElementVNode("i", { class: "fas fa-ellipsis-v text-white" })
        ], -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center mr-3" }, [
            _createElementVNode("i", { class: "fas fa-receipt text-purple-600" })
          ], -1)),
          _createElementVNode("div", null, [
            _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "font-xl text-left" }, "订单详情", -1)),
            _createElementVNode("p", _hoisted_8, "订单号: #" + _toDisplayString(orderNo.value), 1)
          ])
        ]),
        _createElementVNode("span", _hoisted_9, "已用餐: " + _toDisplayString(diningDuration.value), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-gray-600" }, "桌号", -1)),
          _createElementVNode("span", null, _toDisplayString(tableNumber.value) + "号桌", 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-gray-600" }, "用餐人数", -1)),
          _createElementVNode("span", null, _toDisplayString(peopleCount.value) + "人", 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-gray-600" }, "下单时间", -1)),
          _createElementVNode("span", null, _toDisplayString(formatDateTime(orderTime.value)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "py-3 border-b border-gray-100" }, [
        _createElementVNode("h2", { class: "font-semibold" }, "消费明细")
      ], -1)),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderDishes.value, (dish) => {
            return (_openBlock(), _createElementBlock("div", {
              key: dish.name,
              class: "flex justify-between"
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_17, [
                  _createTextVNode(_toDisplayString(dish.name) + " ", 1),
                  (dish.isAddedFood)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, "(加菜)"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_19, "¥" + _toDisplayString(dish.price) + " × " + _toDisplayString(dish.quantity), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", null, "¥" + _toDisplayString((dish.price * dish.quantity).toFixed(2)), 1)
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("span", _hoisted_23, [
              _cache[9] || (_cache[9] = _createTextVNode(" 小计 ", -1)),
              _createElementVNode("span", _hoisted_24, "（共" + _toDisplayString(totalDishCount.value) + "份）", 1)
            ]),
            _createElementVNode("span", null, "¥" + _toDisplayString(subtotal.value.toFixed(2)), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("span", _hoisted_27, "服务费 (" + _toDisplayString(serviceFeeRate.value * 100) + "%)", 1),
              _createElementVNode("button", {
                class: "ml-2 text-purple-500 hover:text-purple-700 text-sm",
                title: "点击调整服务费",
                onClick: adjustServiceFee
              }, _cache[10] || (_cache[10] = [
                _createElementVNode("i", { class: "fas fa-edit" }, null, -1)
              ]))
            ]),
            _createElementVNode("span", null, "¥" + _toDisplayString(serviceFee.value.toFixed(2)), 1)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-gray-600" }, "订单总金额", -1)),
            _createElementVNode("span", null, "¥" + _toDisplayString(totalAmount.value.toFixed(2)), 1)
          ]),
          (paymentAmount.value > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("i", { class: "fas fa-check-circle mr-1" }),
                  _createElementVNode("span", null, "已付金额")
                ], -1)),
                _createElementVNode("span", null, "¥" + _toDisplayString(paymentAmount.value.toFixed(2)), 1)
              ]))
            : _createCommentVNode("", true),
          (discountAmount.value > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("i", { class: "fas fa-tag mr-1" }),
                  _createElementVNode("span", null, "优惠券减免")
                ], -1)),
                _createElementVNode("span", null, "-¥" + _toDisplayString(discountAmount.value.toFixed(2)), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "px-4 py-3 border-b border-gray-100" }, [
        _createElementVNode("h2", { class: "font-semibold" }, "支付方式")
      ], -1)),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentMethods.value, (method) => {
            return (_openBlock(), _createElementBlock("div", {
              key: method.type,
              class: _normalizeClass(["payment-method", { active: selectedPayment.value === method.type }]),
              onClick: ($event: any) => (selectPayment(method.type))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["payment-icon", method.iconClass])
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(method.icon)
                }, null, 2)
              ], 2),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, _toDisplayString(method.name), 1),
                _createElementVNode("div", _hoisted_37, _toDisplayString(method.description), 1)
              ]),
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "payment-check" }, [
                _createElementVNode("i", { class: "fas fa-check-circle" })
              ], -1))
            ], 10, _hoisted_34))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-lg font-bold text-2xl" }, "剩余应付", -1)),
        _createElementVNode("div", _hoisted_40, "¥" + _toDisplayString(finalAmount.value.toFixed(2)), 1)
      ]),
      _createElementVNode("div", { class: "flex space-x-3" }, [
        _createElementVNode("button", {
          class: "flex-1 py-3 border border-purple-600 text-purple-600 rounded-lg font-medium text-2xl",
          onClick: applyDiscount
        }, " 应用优惠 "),
        _createElementVNode("button", {
          class: "flex-1 py-3 bg-purple-600 text-white rounded-lg font-medium text-2xl",
          onClick: completePayment
        }, " 完成支付 ")
      ])
    ]),
    (showQRModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50",
          onClick: hideQRCode
        }, [
          _createElementVNode("div", {
            class: "bg-white rounded-xl p-6 w-80",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("h3", _hoisted_42, _toDisplayString(getPaymentMethodName(selectedPayment.value)), 1),
              _createElementVNode("button", { onClick: hideQRCode }, _cache[18] || (_cache[18] = [
                _createElementVNode("i", { class: "fas fa-times text-gray-500" }, null, -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, "¥" + _toDisplayString(finalAmount.value.toFixed(2)), 1),
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "w-48 h-48 mx-auto bg-gray-100 flex items-center justify-center mb-4" }, [
                _createElementVNode("i", { class: "fas fa-qrcode text-8xl text-gray-400" })
              ], -1)),
              _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-gray-600 mb-2" }, "请顾客扫描二维码完成支付", -1)),
              _createElementVNode("button", {
                class: "bg-purple-600 text-white py-2 px-4 rounded-lg w-full mt-2",
                onClick: simulatePayment
              }, " 模拟支付完成 ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showSuccessModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          _createElementVNode("div", { class: "bg-white rounded-xl p-6 w-80" }, [
            _createElementVNode("div", { class: "text-center" }, [
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4" }, [
                _createElementVNode("i", { class: "fas fa-check-circle text-4xl text-green-500" })
              ], -1)),
              _cache[22] || (_cache[22] = _createElementVNode("h3", { class: "text-xl font-bold mb-2" }, "支付成功", -1)),
              _cache[23] || (_cache[23] = _createElementVNode("p", { class: "text-gray-600 mb-4" }, "订单已成功支付", -1)),
              _createElementVNode("button", {
                class: "bg-purple-600 text-white py-2 px-4 rounded-lg w-full",
                onClick: returnToTables
              }, " 返回桌位页面 ")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})